/**
 * 繁体中文语言包
 * @module lang/zh-TW
 */
export default {
  common: {
    comingSoon: '敬請期待',
    view: '查看',
    show: '顯示',
    hide: '隱藏',
    optional: '可選',
    confirmDeleteYes: '是',
    confirmDeleteNo: '否',
    save: '保存',
    edit: '編輯',
    delete: '刪除',
    deleteCard: '刪除此卡片',
    cancel: '取消',
    confirm: '確定',
    loading: '加載中',
    addSuccess: '添加成功',
    editSuccess: '編輯成功',
    deleteSuccess: '刪除成功',
    imageCropTip: '請將圖片覆蓋整個裁剪區域',
    editPhotoTip: '請調整您的照片位置和大小，通過縮放來實現。然後點擊"保存"確認。',
    back: '返回',
    close: '關閉',
    generateShortUrlTip: '生成短鏈接失敗，請稍後重試',
    generateShareUrlTip: '生成分享鏈接失敗，請稍後重試',
    generateQRCodeTip: '生成二維碼失敗，請稍後重試',
    search: '查詢',
    serialNumber: '序號',
    hint: '提示',
    add: '添加',
    custom: '自定義',
    send: '發送',
    fillRequired: '請填寫必填項',
    exchangeSuccess: '交換成功',
    exchangeFailed: '交換失敗，請稍後重試',
    // 圖片裁剪相關
    cropImage: '裁剪圖片',
    imageToBeCropped: '待裁剪圖片',
    cropperNotInitialized: '裁剪器未初始化',
    cropFailed: '裁剪失敗',
    convertImageFailed: '轉換圖片失敗',
    displayText: '展示文本',
    linkCopied: '已複製到剪貼板',
    linkCopiedError: '複製失敗，請手動複製',
    linkCopiedErrorTip: '請手動複製鏈接',
  },
  navFooterTabber: {
    myECard: '名片',
    home: '首頁',
    create: '創建',
    my: '我的',
    createTitle: '創建名片',
    cardDetail: '名片詳情',
    cardPreview: '名片預覽',
    login: '登錄',
    templateManagement: '模板管理',
    maxCardNum: '最大支持創建3張名片',
    companyManagement: '企業管理',
    employeeManagement: '員工管理',
    companyInfo: '企業信息',
    systemManagement: '系統管理',
    userManagement: '用戶管理',
    customerManagement: '客戶關係管理',
    platformCompany: '企業客戶管理',
  },
  home: {
    myCardHolder: '我的名片',
    homeDesc: '管理您的專業形象',
    total: '共',
    businessCards: '已創建的名片',
    startCreate: '創建你的第一張名片',
    startCreateDesc: '快速高效地分享您的最新信息，建立您的聯繫關係。將初次見面轉化為持久的聯繫。',
    createCardButton: '創建我的第一張名片',
  },
  createCard: {
    createTitle: '創建名片',
    editTitle: '編輯名片',
    templateType: '模板類型',
    selectTemplate: '選擇模板',
    Classic: '經典',
    Ribbol: '絲帶',
    BigHead: '全屏',
    Landscape: '海報',
    themeColor: '主題顏色',
    livePreview: '實時預覽',
    create: '創建',
    save: '保存',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確定要刪除此名片嗎？',
    confirmDeleteYes: '是',
    confirmDeleteNo: '否',
    display: '展示',
    color: '顏色',
    black: '黑色',
    white: '白色',
    gray: '灰色',
    green: '綠色',
    blue: '藍色',
    cardBackground: '實體名片背景',
    physicalCardPreview: '實體名片預覽',
    uploadPhysicalCard: '上傳製卡背景',
    uploadPhysicalCardBack: '上傳製卡背景背面',
    front: '正面',
    back: '背面',
    basicInfo: '基本信息',
    links: '鏈接',
    prefix: '前綴',
    name: '姓名',
    suffix: '後綴',
    yourName: '您的姓名',
    jobTitle: '職務',
    yourPosition: '您的職務',
    company: '公司',
    yourCompany: '您的公司',
    contactInfo: '聯繫信息',
    email: '郵箱',
    yourEmail: '您的郵箱',
    selectLinkType: '選擇鏈接類型',
    addLink: '添加鏈接',
    linkName: '鏈接名稱',
    linkNamePlaceholder: '請輸入鏈接名稱',
    linkAddress: '鏈接地址',
    linkAddressPlaceholder: '請輸入鏈接地址',
    selectIcon: '選擇圖標',
    mobile: '手機',
    addMobile: '添加手機',
    direct: '直撥',
    addDirect: '添加直撥',
    phone: '座機',
    addPhone: '添加座機',
    yourPhone: '您的電話',
    landline: '座機',
    addLandline: '添加座機',
    yourLandline: '您的座機',
    website: '網站',
    address: '地址',
    yourAddress: '您的地址',
    country: '國家',
    city: '城市',
    postcode: '郵政編碼',
    socialMedia: '社交媒體',
    pleaseEnterFullLinks: '請填寫完整的鏈接',
    productIntroduction: '產品介紹',
    wechat: '微信',
    wechatId: '微信號',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    other: '其他',
    channelName: '頻道名稱',
    newChannel: '新頻道',
    profileLink: '頻道鏈接',
    displayText: '顯示文本',
    pictureInformation: '圖片信息',
    companyLogo: '公司Logo',
    companyLogoDesc: '上傳您的公司Logo',
    IDPhoto: '個人照片',
    IDPhotoDesc: '上傳您的個人照片',
    nameRequired: '請填寫姓名',
    jobTitleRequired: '請填寫職務',
    companyRequired: '請填寫公司名稱',
    emailRequired: '請填寫郵箱',
    emailFormatError: '請輸入正確的郵箱格式',
    phoneRequired: '請填寫電話號碼',
    addressRequired: '請填寫地址',
    companyLogoRequired: '請上傳公司Logo',
    IDPhotoUploadSuccess: '個人照片上傳成功',
    companyLogoUploading: '上傳中...',
    companyLogoUploadMaxSize: '請上傳小於30M的圖片',
    companyLogoUploadSuccess: '上傳成功',
    companyLogoUploadFormat: '請上傳jpg/png格式的圖片',
    companyLogoUploadTip: '*推薦使用透明背景的png文件',
    reUpload: '重新上傳',
    uploadImage: '上傳圖片',
    uploadImageDesc: '為了呈現最佳製卡效果，請上傳分辨率大於等於 1712 × 1080 像素的 JPG 或 PNG 格式高清圖片。',
    physicalCardInfo: '實體卡信息',
    physicalCardInfoDesc: '自定義您的實體名片外觀',
    expand: '展開',
    collapse: '收起',
    selectLayout: '選擇佈局',
    layoutDesc: '選擇您的實體名片佈局',
    backgroundCategory: '背景分類',
    selectBackground: '選擇背景',
    textColor: '文字顏色',
    plainColours: '純色',
    gradients: '漸變',
    gradientStrips: '漸變條紋',
    geometricBackground: '幾何背景',
    bottomLine: '底部線條',
    waves: '波浪',
    geometricLines: '幾何線條',
    darkGray: '深灰',
    navy: '藏青',
    darkGreen: '墨綠',
    darkRed: '深紅',
    gold: '金色',
    bluePurple: '藍紫',
    pinkRed: '粉紅',
    blueCyan: '藍青',
    goldOrange: '金橙',
    ocean: '海洋',
    sunset: '日落',
    forest: '森林',
    rainbow: '彩虹',
    blueRed: '藍紅',
    lightGray: '淺灰',
    whiteDots: '白點',
    darkDots: '暗點',
    whiteGrid: '白格',
    darkGrid: '暗格',
    goldLine: '金線',
    blueLine: '藍線',
    redLine: '紅線',
    darkGold: '暗金',
    blueWave: '藍波',
    greenWave: '綠波',
    orangeWave: '橙波',
    whiteLines: '白線',
    darkLines: '暗線',
    goldLines: '金線',
    blueLines: '藍線',
    // 產品介紹卡片
    simple: 'Simple',
    socialMediaTitle: 'Social Media',
    productCatalog: 'Product Catalog',
    show: '顯示',
    hide: '隱藏',
    image: '圖片',
    icon: '圖標',
    productIntroductionName: '名稱',
    url: '鏈接',
    description: '描述',
    pleaseEnterDescription: '請輸入描述',
    pleaseEnterName: '請輸入名稱',
    pleaseEnterAddress: '請輸入地址',
    selectIconFromProvided: '從提供的圖標中選擇',
    uploadFile: '上傳文件',
    addCustomInfo: '新增自定義資訊',
    customInfo: '自定義資訊',
    learnMore: '了解更多',
    // 社交媒體平台名稱
    prdYoutube: 'YouTube',
    prdFacebook: 'Facebook',
    prdInstagram: 'Instagram',
    prdLinkedIn: 'LinkedIn',
    prdWeibo: '微博',
    prdXiaohongshu: '小紅書',
    // 錯誤提示
    imageFormatError: '僅支持 PNG 和 JPG 格式的圖片',
    imageSizeError: '圖片大小不能超過 {size}MB',
    fileFormatError: '僅支持 PDF、Word、Excel、PPT 格式的文件',
    fileSizeError: '文件大小不能超過 20MB',
    fileUploadError: '文件上傳失敗，請重試',
    imageUploadError: '圖片上傳失敗，請重試',
    uploadSuccess: '上傳成功',
    // alt 屬性翻譯
    avatarPreview: '頭像預覽',
    imagePreview: '圖片預覽',
    iconPreview: '圖標預覽',
    requiredLink: '為必填項，請填寫',
  },
  /** 鏈接分類名稱 */
  linkCategories: {
    popular: '常用推薦',
    social: '社交媒體',
    messaging: '通訊',
    meeting: '會議',
    payment: '支付',
    video: '視頻',
    music: '音樂',
    design: '設計',
    gaming: '遊戲',
    other: '其他',
  },
  /** 鏈接標籤名稱 */
  linkLabels: {
    phone: '手機',
    address: '地址',
    directCall: '直拨',
    telephone: '座機',
    website: '網站',
    link: '鏈接',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    facebook: 'Facebook',
    xcom: 'X.com',
    snapchat: 'Snapchat',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    pinterest: 'Pinterest',
    twitch: 'Twitch',
    xing: 'Xing',
    threads: 'Threads',
    weibo: '微博',
    qq: 'QQ',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    discord: 'Discord',
    wechat: '微信',
    line: 'Line',
    signal: 'Signal',
    fax: '傳真',
    zoom: 'Zoom',
    teams: 'Teams',
    meet: 'Meet',
    skype: 'Skype',
    webex: 'Webex',
    venmo: 'Venmo',
    paypal: 'PayPal',
    cashapp: 'CashApp',
    zelle: 'Zelle',
    brightcove: 'Brightcove',
    vimeo: 'Vimeo',
    spotify: 'Spotify',
    applemusic: 'Apple Music',
    soundcloud: 'SoundCloud',
    behance: 'Behance',
    dribbble: 'Dribbble',
    psn: 'PSN',
    xboxlive: 'Xbox Live',
    nintendo: 'Nintendo',
    github: 'GitHub',
    calendly: 'Calendly',
    patreon: 'Patreon',
    yelp: 'Yelp',
    microsoftbookings: 'Microsoft Bookings',
  },
  /** 鏈接輸入框佔位符 */
  linkPlaceholders: {
    phone: '請輸入手機號',
    address: '請輸入地址',
    directCall: '請輸入直拨號',
    telephone: '請輸入座機號',
    website: '請輸入網站鏈接',
    link: '請輸入鏈接',
    instagram: '請輸入Instagram鏈接',
    linkedin: '請輸入LinkedIn鏈接',
    facebook: '請輸入Facebook鏈接',
    xcom: '請輸入X.com鏈接',
    snapchat: '請輸入Snapchat鏈接',
    tiktok: '請輸入Tiktok鏈接',
    youtube: '請輸入Youtube鏈接',
    pinterest: '請輸入Pinterest鏈接',
    twitch: '請輸入Twitch鏈接',
    xing: '請輸入Xing鏈接',
    threads: '請輸入Threads鏈接',
    weibo: '請輸入微博鏈接',
    qq: '請輸入QQ號',
    whatsapp: '請輸入WhatsApp鏈接',
    telegram: '請輸入Telegram鏈接',
    discord: '請輸入Discord鏈接',
    wechat: '請輸入微信號',
    line: '請輸入Line鏈接',
    signal: '請輸入Signal鏈接',
    fax: '請輸入傳真號',
    zoom: '請輸入Zoom鏈接',
    teams: '請輸入Teams鏈接',
    meet: '請輸入Meet鏈接',
    skype: '請輸入Skype鏈接',
    webex: '請輸入Webex鏈接',
    venmo: '請輸入Venmo鏈接',
    paypal: '請輸入PayPal鏈接',
    cashapp: '請輸入CashApp鏈接',
    zelle: '請輸入Zelle鏈接',
    brightcove: '請輸入Brightcove鏈接',
    vimeo: '請輸入Vimeo鏈接',
    spotify: '請輸入Spotify鏈接',
    applemusic: '請輸入Apple Music鏈接',
    soundcloud: '請輸入SoundCloud鏈接',
    behance: '請輸入Behance鏈接',
    dribbble: '請輸入Dribbble鏈接',
    psn: '請輸入PSN鏈接',
    xboxlive: '請輸入Xbox Live鏈接',
    nintendo: '請輸入Nintendo鏈接',
    github: '請輸入GitHub鏈接',
    calendly: '請輸入Calendly鏈接',
    patreon: '請輸入Patreon鏈接',
    yelp: '請輸入Yelp鏈接',
    microsoftbookings: '請輸入Microsoft Bookings鏈接',
    required: '必填',
  },
  cardDetail: {
    templatePreview: '模板預覽',
    company: '公司',
    address: '地址',
    landline: '座機',
    mobile: '手機號',
    direct: '直撥',
    email: '郵箱',
    website: '網站',
    socialMedia: '社交媒體',
    wechat: '微信',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    confirmDelete: '確定要刪除嗎？',
    confirmDeleteDesc: '此操作將永久刪除此名片，請謹慎操作。',
    editCard: '編輯名片',
    deleteCard: '刪除名片',
    saveCard: '保存名片',
    shareLink: '分享鏈接',
    copyLink: '復製鏈接',
    generatingCardImage: '正在生成名片圖片...',
    cardImageGenerated: '名片圖片已生成',
    cardImageGeneratedError: '生成名片圖片失敗，請稍後再試',
    cardImageGeneratedSuccess: '電子名片',
    shareCard: '分享名片',
    saveToContacts: '保存到通訊錄',
    vCardGeneratedSuccess: 'vCard文件已生成，請下載並導入到通訊錄',
    vCardGeneratedError: '生成vCard文件失敗，請重試',
    readingCard: '正在讀取名片...',
    addByCardPage: '通過數字名片頁面添加',
    saveFailed: '保存失敗，請重試',
    linkCopied: '鏈接已復製到剪貼板',
    linkCopiedError: '鏈接復製失敗，請手動復制鏈接',
    linkCopiedErrorTip: '請手動復制鏈接',
    previewCard: '預覽名片',
    savePhysicalCard: '保存製卡名片',
    viewPhysicalBusinessCards: '查看製卡名片',
    pushPhysicalBusinessCards: '推送製卡名片',
    pushPhysicalBusinessCardsSuccess: '製卡名片已推送成功',
    pushPhysicalBusinessCardsError: '製卡名片推送失敗，請重試',
    pushPhysicalBusinessCardsErrorTip: '請檢查網絡連接，並重試',
    pushPhysicalBusinessCardsSuccessTip: '製卡名片已推送成功，請耐心等待',
    pushPhysicalBusinessCardsErrorTip2: '請檢查網絡連接，並重試',
    terminalScanningTwoDimensionalCodeBusinessCardPrinting: '終端掃描二維碼製卡',
    saveContact: '保存聯繫人',
    exchangeContact: '交換聯繫人',
    shareYourContact: '把你的聯繫方式分享給',
    firstName: '名',
    lastName: '姓',
    phoneNumber: '電話',
  },
  my: {
    logOut: '退出登錄',
    language: '語言設置',
    chinese: '簡體中文',
    english: 'English',
    profile: '個人中心',
    changePassword: '修改密碼',
    quickActions: '快速操作',
    oldPassword: '舊密碼',
    enterOldPassword: '請輸入舊密碼',
    newPassword: '新密碼',
    enterNewPassword: '請輸入新密碼',
    enterConfirmPassword: '請確認新密碼',
    confirmPasswordError: '新密碼和確認密碼不一致',
    confirmPassword: '確認新密碼',
    newPasswordLengthError: '新密碼長度不能小於6位',
    samePasswordError: '新密碼不能與舊密碼相同',
    changePasswordSuccess: '密碼修改成功',
    changePasswordFailed: '密碼修改失敗，請重試',
    oldPasswordError: '舊密碼錯誤',
    logOutSuccess: '退出登錄成功',
    logOutConfirm: '退出登錄確認',
  },
  login: {
    welcome: '歡迎回來',
    subtitle: '登錄以繼續使用您的賬戶',
    subtitleTip: '對於新用戶，請輸入您的首選電子郵件和新密碼進行註冊',
    usernamePlaceholder: '請輸入用戶名或郵箱',
    passwordPlaceholder: '請輸入密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼？',
    loginButton: '登錄/註冊',
    login: '登錄',
    loggingIn: '登錄中...',
    noAccount: '還沒有賬號？',
    register: '立即註冊',
    usernameRequired: '請輸入用戶名或郵箱',
    passwordRequired: '請輸入密碼',
    loginSuccess: '登錄成功',
    forgotPasswordTip: '忘記密碼功能開發中',
    registerTip: '註冊功能開發中',
    passwordMinLength: '密碼長度不能小於6位',
    loginError: '用戶名或密碼錯誤',
    usernameMinLength: '用戶名長度不能小於5位',
    brandSlogan: '數字名片 · 智能連接',
    loginErrorTip: '登錄失敗次數過多，賬戶已被鎖定15分鐘',
    usernameOrPasswordErrorTip: '用戶名或密碼錯誤',
    remainingAttempts: '剩餘 {remaining} 次嘗試機會',
    locked: '賬戶已被鎖定，請在 {remaining} 秒後重試',
    signUp: '註冊賬號',
  },
  register: {
    firstName: '名',
    firstNamePlaceholder: '請輸入名',
    firstNameRequired: '請輸入名',
    lastName: '姓',
    lastNamePlaceholder: '請輸入姓',
    lastNameRequired: '請輸入姓',
    email: '郵箱',
    emailPlaceholder: '請輸入郵箱',
    emailRequired: '請輸入郵箱',
    emailInvalid: '請輸入有效的郵箱地址',
    username: '用戶名',
    usernamePlaceholder: '請輸入用戶名',
    usernameRequired: '請輸入用戶名',
    usernameInvalid: '用戶名至少3個字符，只能包含字母、數字和下劃線',
    password: '密碼',
    passwordPlaceholder: '請輸入密碼',
    passwordRequired: '請輸入密碼',
    passwordInvalid: '密碼至少6個字符',
    confirmPassword: '確認密碼',
    confirmPasswordPlaceholder: '請再次輸入密碼',
    confirmPasswordRequired: '請確認密碼',
    passwordMismatch: '兩次輸入的密碼不一致',
    registerButton: '註冊',
    hasAccount: '已有賬號？',
    loginNow: '立即登錄',
    emailExists: '該郵箱已被註冊',
    usernameExists: '該用戶名已被使用',
    registerSuccess: '註冊成功！請登錄',
  },
  companyInfo: {
    companyName: '公司名稱',
    companyNameDesc: '請輸入您的公司名稱',
    companyAddress: '公司地址',
    companyAddressDesc: '請輸入您的公司地址',
    companyLogo: '公司Logo',
    companyLogoDesc: '請上傳您的公司Logo',
    entityCardBg: '實體卡背景',
    entityCardBgDesc: '請上傳您的實體卡背景',
  },
  employee: {
    employeeName: '員工姓名',
    employeeNameDesc: '請輸入員工姓名',
    addEmployee: '添加員工',
    employeeNo: '員工編號',
    employeeNoDesc: '請輸入員工編號',
    employeeId: '員工ID',
    name: '姓名',
    nameDesc: '請輸入員工姓名',
    department: '部門',
    departmentDesc: '請輸入員工部門',
    position: '職務',
    positionDesc: '請輸入員工職務',
    mobile: '手機號',
    mobileDesc: '請輸入員工手機號',
    email: '郵箱',
    emailDesc: '請輸入員工郵箱',
    status: '狀態',
    statusDesc: '請選擇員工狀態',
    statusActive: '在職',
    statusInactive: '離職',
    operation: '操作',
    confirmDelete: '確認刪除該員工嗎？',
    userExist: '用戶已存在',
    emailExist: '郵箱已存在',
    userNotExist: '用戶不存在',
  },
  userManagement: {
    username: '用戶名',
    usernameDesc: '請輸入用戶名',
    nickname: '暱稱',
    email: '郵箱',
    status: '狀態',
    statusActive: '啟用',
    statusInactive: '禁用',
    operation: '操作',
    changePassword: '修改密碼',
    resetPassword: '重置密碼',
    newPassword: '新密碼',
    newPasswordDesc: '請輸入新密碼',
    confirmPassword: '確認密碼',
    confirmPasswordDesc: '請再次輸入新密碼',
    changePasswordSuccess: '修改密碼成功',
    changePasswordFailed: '修改密碼失敗',
    resetPasswordSuccess: '重置密碼成功',
    resetPasswordFailed: '重置密碼失敗',
    passwordLengthError: '密碼長度在6到20個字符',
    passwordMismatchError: '兩次輸入的密碼不一致',
    confirmResetPassword: '確認重置該用戶的密碼嗎？',
  },
  customerManagement: {
    pageTitle: '客戶管理',
    pageDesc: '管理您的客戶聯繫人',
    name: '姓名',
    namePlaceholder: '請輸入姓名',
    company: '公司',
    companyPlaceholder: '請輸入公司名稱',
    phone: '電話',
    phonePlaceholder: '請輸入電話號碼',
    email: '郵箱',
    emailPlaceholder: '請輸入郵箱地址',
    department: '部門',
    departmentPlaceholder: '請輸入部門',
    jobTitle: '職位',
    jobTitlePlaceholder: '請輸入職位',
    createDate: '創建日期',
    startDate: '開始時間',
    endDate: '結束時間',
    to: '至',
    reset: '重置',
    add: '新增',
    addCustomer: '新增客戶',
    editCustomer: '編輯客戶',
    deleteConfirm: '確認刪除該客戶嗎？',
    more: '更多',
    firstName: '名',
    lastName: '姓',
    firstNamePlaceholder: '請輸入名',
    lastNamePlaceholder: '請輸入姓',
    firstNameRequired: '請輸入名',
    lastNameRequired: '請輸入姓',
    firstNameMaxLength: '名最多30個字符',
    lastNameMaxLength: '姓最多30個字符',
    phoneRequired: '請輸入電話號碼',
    phoneFormatError: '請輸入正確的電話號碼格式',
    companyRequired: '請輸入公司名稱',
    companyMaxLength: '公司名稱最多60個字符',
    emailFormatError: '請輸入正確的郵箱格式',
    departmentMaxLength: '部門最多60個字符',
    jobTitleMaxLength: '職位最多60個字符',
  },
  platformCompany: {
    name: '名稱',
    namePlaceholder: '請輸入企業客戶名稱',
    email: '郵箱',
    emailPlaceholder: '請輸入郵箱',
    phone: '聯繫電話',
    phonePlaceholder: '請輸入聯繫電話',
    createDate: '創建時間',
    startDate: '開始時間',
    endDate: '結束時間',
    to: '至',
    add: '新增',
    resetSearch: '重置查詢',
    companyName: '企業客戶名稱',
    code: '編號',
    contactName: '聯繫人',
    contactNamePlaceholder: '請輸入聯繫人',
    operation: '操作',
    addCompany: '新增企業客戶',
    editCompany: '編輯企業客戶',
    website: '網址',
    websitePlaceholder: '請輸入企業網址',
    userName: '用戶名',
    admins: '企業管理員',
    adminName: '姓名',
    adminNamePlaceholder: '請輸入姓名',
    adminEmail: '郵箱',
    adminEmailPlaceholder: '請輸入郵箱',
    adminUserName: '用戶名',
    adminUserNamePlaceholder: '請輸入用戶名',
    adminMaxTip: '最多配置3個管理員',
    submit: '提交',
    refill: '重填',
    deleteConfirm: '確定刪除該企業客戶嗎？刪除後數據將無法恢復。',
    nameRequired: '請輸入企業客戶名稱',
    nameMaxLength: '企業客戶名稱最多50個字符',
    contactNameRequired: '請輸入聯繫人',
    contactNameMaxLength: '聯繫人最多20個字符',
    phoneRequired: '請輸入聯繫電話',
    phoneFormatError: '請輸入正確的手機號',
    emailRequired: '請輸入郵箱',
    emailFormatError: '請輸入正確的郵箱格式',
    websiteMaxLength: '網址最多100個字符',
    adminNameRequired: '請輸入管理員姓名',
    adminEmailRequired: '請輸入管理員郵箱',
    adminEmailFormatError: '請輸入正確的郵箱格式',
    adminUserNameRequired: '請輸入管理員用戶名',
    adminUserNameInvalid: '用戶名至少3個字符，只能包含字母、數字和下劃線',
  },
  errorCodeMap: {
    tokenExpired: '賬戶信息已過期或已在別處登錄，請重新登錄',
    systemException: '系統異常，請請聯繫管理員',
    systemError: '系統異常，請聯繫管理員處理',
    networkError: '請檢查網絡',
    '000000': '數據庫查詢失敗',
    '000001': '數據庫添加失敗',
    '000002': '數據庫修改失敗',
    '000003': '數據庫刪除失敗',
    '000004': '數據庫查詢 為空',
    '000005': '批量插入失敗',
    '010000': '連接失敗',
    '010001': '發送失敗',
    '010002': '接收失敗',
    '010003': '發送超時',
    '010004': '接收超時',
    '010005': 'feign調用失敗',
    '010006': 'feign調用超時',
    '010007': '服務限流',
    '010008': '無法從服務註冊中心獲取服務信息',
    '010009': '發送信息失敗',
    '010010': '發送或接收異常',
    '020000': '文件不存在',
    '020001': '文件夾不存在',
    '020002': '無法讀取文件',
    '020003': '無法寫文件',
    '020004': '保存文件失敗',
    '020005': '文件名存在',
    '020006': '文件夾名存在',
    '020007': '未知文件格式.',
    '020008': '轉換文件失敗.',
    '030000': '內存不足',
    '040000': '參數為空',
    '040001': '參數不合法',
    '040002': '數據驗證錯誤',
    '040003': '無參數更新',
    '040004': 'id為空',
    '040005': '數據轉換異常',
    '050000': '用戶已被邀請',
    '050001': '用戶已存在',
    '050002': '未授權',
    '050003': '用戶不存在',
    '050004': '邀請碼不存在',
    '050005': '未知業務類型',
    '050006': '轉換微信支付的xml失敗',
    '050007': '解析xml異常',
    '050008': '微信返回錯誤',
    '050009': '無退款記錄',
    '050010': '用戶未登錄',
    '050011': '驗證碼不 正確',
    '050012': '驗證碼失效或不存在',
    '050013': '賬戶狀態異常',
    '050014': '靜態化頁面錯誤',
    '050015': '用戶未通過審核',
    '050016': '授權信息已存在',
    '050017': '設置商品類失敗',
    '050018': '設置商品失敗',
    '050019': '設置商品SPU屬性失敗',
    '050020': '設置商品SKU屬性失敗',
    '050021': '設置商品圖片失敗',
    '050022': '設置門店商品失敗',
    '050023': '設置規格商品失敗',
    '050024': '設置商品套餐失敗',
    '050025': '獲取商品碼失敗',
    '050026': '商品、分類已關聯',
    '050027': '用戶未關聯商戶',
    '050028': '登錄權限已過期',
    '050029': '更新商戶登錄token失敗',
    '050030': '分類、打印機已關聯',
    '050031': '支付金額異常',
    '050032': '無消費記錄',
    '050033': '退款時間已過期',
    '050034': '退款金額異常',
    '050035': 'uuid重複',
    '050036': '數據異 常',
    '050037': '登錄失敗',
    '050038': '註冊失敗',
    '050039': '重複消費',
    '050040': '賬戶或密碼錯誤',
    '050041': '未知交易',
    '050042': '交易金額不足',
    '050043': '交易失敗',
    '050044': '訂單不存在或失效',
    '050045': '已經被綁定',
    '050046': '存在下級',
    '050047': '名稱重複',
    '050048': '上傳圖片失敗 ',
    '050049': '已綁定用戶',
    '050050': '商戶配置信息不存在',
    '050051': '獲取微信小程序登錄態失敗',
    '050052': '解密數據失敗',
    '050053': 'ES查詢失敗',
    '050054': 'ES添加失敗',
    '050055': 'ES修改失敗',
    '050056': 'ES刪除失敗',
    '050057': 'ES查詢為空',
    '050058': 'ES刪除索引失敗',
    '050059': '商戶角色為空',
    '050060': '不存在該特色服務的配置',
    '050061': '查詢機構信息失敗',
    '050062': '獲取商戶信息失敗',
    '050063': '腳本執行失敗',
    '050064': 'Token失效',
    '050065': '編號已經存在',
    '050066': '待分配數量過大',
    '050067': '內置信息，不能刪除',
    '050068': '配置商戶信息失敗',
    '050069': '該商戶存在失敗開通記錄',
    '050070': '導出文件失敗',
    '050071': '執行清分失敗',
    '050072': '無清分數據',
    '050073': '緩存數據失敗',
    '050074': '執行對賬失敗',
    '050075': '對賬金額異常',
    '050076': '賬戶已停用',
    '050077': '商戶未授權',
    '050078': '用戶無權限',
    '050079': '未分配數量小於待分配數量',
    '050080': '設備編碼解析失敗',
    '050081': '設備編碼生產工廠解析失敗',
    '050082': '設備編碼品牌解析失敗',
    '050083': '設備編碼類型解析失敗',
    '050084': '設備編碼批次號解析失敗',
    '050085': '設備編碼型號解析失敗',
    '050086': '設備分配失敗',
    '050087': '設備編碼為空',
    '050088': '設備編碼長度  不正確',
    '050089': '模板已被使用',
    '050090': '人員已被通知組使用',
    '050091': '菜單查詢為空',
    '050092': '機構已綁定賬號',
    '050093': '賬戶異常',
    '050094': '原始密碼錯誤',
    '050095': '訂單異常，請重新下單',
    '050096': '支付異常',
    '050097': '活動信息異常',
    '050098': '獲取用戶信息錯誤',
    '050099': '庫存不足',
    '050100': 'security_uuid重複',
    '050101': '轉入退款',
    '050102': '未支付',
    '050103': '已關閉',
    '050104': '已撤銷',
    '050105': '用戶支 付中',
    '050106': '支付失敗',
    '050107': '數據流關閉異常',
    '050108': '權限已存在',
    '050109': '配置文件為空',
    '050110': '時間格式錯誤',
    '050111': '開始時間不合法',
    '050112': '結束時間不合法',
    '050113': '活動時間衝突',
    '050114': '活動名稱衝突',
    '050115': '場景已關聯任務',
    '050116': '場景已關聯業務類型',
    '050117': '規則組已關聯業務類型',
    '050118': '業務類型已關聯任務',
    '050119': '圖片不合規',
    '050120': '圖片分組不一致',
    '050121': '無法獲取應用數據準備腳本信息.',
    '050123': '名稱已存在.',
    '050124': '系統內部錯誤.',
    '050125': '獲取卡號失敗.',
    '050126': '獲取應用密鑰失敗.',
    '050127': '無法獲取加密機腳本信息.',
    '050128': '運算錯誤.',
    '050129': '密鑰分散因子長度有誤.',
    '050130': 'IP未授權.',
    '050131': '獲取加密機信 息失敗',
    '050132': '獲取RSA秘鑰規則失敗',
    '050133': '獲取TK失敗',
    '050134': '獲取系統LMK索引失敗',
    '050135': '獲取應用信息異常',
    '050136': '獲取應用密鑰信息異常',
    '050137': '獲取秘鑰索引等信息異常',
    '050138': '獲取秘鑰索引為空',
    '050139': '獲取發卡行證書為空',
    '050140': '從加密機獲取發卡行秘鑰信息失敗!',
    '050141': '獲取對稱秘鑰信息失敗',
    '050142': '獲取對稱AC秘鑰信息失敗',
    '050143': '從加密機獲取秘鑰失敗!',
    '050144': '獲取應用綁定的秘鑰信息失敗',
    '050145': '獲取密鑰規則失敗',
    '050146': '獲取未使用的IC卡非對稱密鑰失敗',
    '050147': '獲取發卡行索引失敗',
    '050148': '從加密機獲取ic卡非對稱密鑰信息失敗',
    '050149': '應用已綁定密鑰，請解綁後刪除',
    '050150': '應用下子應用密鑰存在已綁定密鑰，請解綁後刪 除!',
    '050151': '應用不符合綁定條件',
    '050152': '密鑰不符合綁定條件',
    '050153': '此加密機已被設置的密鑰綁定，不能時除!',
    '050154': '加密機廠商下有正在使用的加密機不允許刪除',
    '050155': '密鑰已綁定，請解綁後再刪除!',
    '050156': '密鑰下子密鑰存在已綁定應用，請解綁後刪除!',
    '050157': '該應用已經配置了密鑰池',
    '050158': '獲取應用配置已關閉',
    '050159': '應用綁定類型異常!',
    '050160': '更新綁定的密鑰狀態失敗!',
    '050161': '密鑰綁定類型異常',
    '050162': '應用密鑰名稱已存在!',
    '050163': '創建綁定的子密鑰信息失敗!',
    '050164': '應用已綁定，請解綁後再編輯!',
    '050165': '規則已綁定，不允許刪除',
    '050166': '添加定時任務信息失敗!',
    '050167': '刪除定時任務信息失敗!',
    '050168': '此應用已配置任務信息，不能重複配  置',
    '050169': '未綁定加密機',
    '050170': '獲取CA信息異常',
    '990000': '未知錯誤信息',
    '060100': '名片不存在',
    '060101': '名片不存在或已下線',
    '060102': '名片已下線或不可用',
    '060103': '名片未發布，無法分享',
    '060104': '無權分享該名片',
    '060105': '生成QR碼失敗',
    '060106': '已經收藏過該名 片',
    '060107': '收藏失敗',
    '060108': '未找到收藏記錄',
    '060109': '取消收藏失敗',
    '060200': '郵箱已存在', // 用戶名已存在
    '060201': '企業註冊失敗',
    '060202': '用戶不存在',
    '060203': '企業不存在',
    '060204': '無權查看該企業信息',
    '060205': '更新企業信息失敗',
    '060206': '無權操作其他企業',
    '060207': '操作用戶不存在',
    '060208': '無權操作',
    '060209': '員工編號已存在',
    '060210': '添加員工失敗',
    '060211': '用戶未關聯企業',
    '060212': '只有企業管理員可以執行此操作',
    '060213': '員工不存在',
    '060214': '該員工不屬於此企業',
    '060215': '該用戶不是企業員工',
    '060216': '無權查看該企業員工列表',
    '060217': '更新員工信息失敗',
    '060218': '管理員用戶創建失敗',
    '060300': 'method參數不能為空',
    '060301': '未知的API',
    '060400': 'refresh token 無效或已過期',
    '060401': '無效的refresh token',
    '060402': 'refresh token已被使用或不存在',
    '060403': '請求體錯誤',
    '060404': '請求路徑不允許',
    '060405': '請求方法為空',
    '060406': '授權請求頭錯誤',
    '060407': '令牌為空',
    '060408': '令牌無效',
    '060409': '令牌解析錯誤',
    '060411': '無效請求',
    '060412': '缺少時間戳或簽名',
    '060413': '請求已過期',
    '060414': '重複請求'
  }
}
